import React from 'react'
import { usePipeline } from '@morningtrain/react-helpers'
import { useForm } from '../hooks'

function TriggerPipelineOnFormSubmit () {
  const pipeline = usePipeline()
  const form = useForm()

  const handleOnSubmit = (data) => {
    const payload = { data }

    pipeline.trigger(payload)
      .catch((err) => console.log('caught error', err))
  }

  React.useEffect(() => {
    form.onSubmit(handleOnSubmit)

    return () => {
      form.removeOnSubmitListener(handleOnSubmit)
    }
  })

  return null
}

export default TriggerPipelineOnFormSubmit
